import type { Saga } from "redux-saga";
import {
  call, debounce, put, select,
} from "redux-saga/effects";
import {
  addNotification,
  changeTableItemsTotalAmount,
  setTableData,
  setTableSelection,
  getTableFilters,
  getTablePage,
  getTablePageSize,
  getTableSorting,
  parseResponse,
  type Filters,
  type Sorting,
} from "@fas/ui-framework";
import setLoading from "../../actions/loading";
import { GET_LINKING_LIST_SAGA, LINKING_LIST } from "../../helpers/constants";
import LinkingApi from "../../services/linkingApi";
import type { LinkingInfo } from "../../components/LinkingInfoForm/types/LinkingInfoForm.types";

export function* makeFetch() {
  try {
    yield put(setLoading(LINKING_LIST, true));
    const filters: Filters = yield select(getTableFilters, LINKING_LIST);
    const sorting: Sorting = yield select(getTableSorting, LINKING_LIST);
    const page: number = yield select(getTablePage, LINKING_LIST);
    const pageSize: number = yield select(getTablePageSize, LINKING_LIST);

    const response: {
      data: {
        data: { count: number, data: Array<LinkingInfo> },
      },
    } = yield call(LinkingApi.getLinkingList as any, {
      filters,
      sorting,
      page,
      pageSize,
    });
    const {
      data: {
        data: { count, data: linkingList },
      },
    } = response;

    yield put(setTableData(LINKING_LIST, linkingList));
    yield put(changeTableItemsTotalAmount(LINKING_LIST, count));
  }
  catch (error: any) {
    yield put(addNotification({ message: parseResponse(error), severity: "error" }));
    // eslint-disable-next-line no-console
    console.error(error);
    yield put(changeTableItemsTotalAmount(LINKING_LIST, 0));
    yield put(setTableData(LINKING_LIST, []));
    yield put(setTableSelection(LINKING_LIST, []));
  }
  finally {
    yield put(setLoading(LINKING_LIST, false));
  }
}

export default function* watch() {
  yield debounce(1000, GET_LINKING_LIST_SAGA, makeFetch);
}
